import { DecorationModel } from "../_model/DecorationModel";
import { ControllerConnection } from "../connection/controllerConnection"
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { COLORS } from "../../utils/colors"
import * as d3 from "d3"
import Resize from "../_decorationTools/risezeClass";
import { SingletonInter } from "../_service/singletonInter";

export class DecorationInputCana extends DecorationModel {
  constructor() {
    super("DecorationInputCana")
    this.node = null;
    this.busyConnection = false;
    this.ctrConnection = new ControllerConnection();
    let resize = new Resize();
  
    this.init = async function (newNode, openDialog) {
      let svg = SingletonFlowchart.svg
      this.node = newNode;
      this.dialog = openDialog
  
       await svg
          .data([newNode])
          .append("g")
          .classed("InputCana", true)
          .attr("id", `InputCana-${newNode.id}`)

          let g = d3.select(`#InputCana-${newNode.id}`)
          
          g.append("image")
            .attr('width', newNode.widthImg)
            .attr('height', newNode.heightImg)
            .attr("x", newNode.x)
            .attr("y", newNode.y)
            .attr("xlink:href", newNode.srcImg)
            .style("cursor", "pointer")
            .on('dblclick', newNode.showBox ? () => this.setDoubleClick() : () => {})
            .on('click', newNode.showBox ? () => this.setOnClick() : () => {})
            .on("mouseover",  resize.mouseOver)
            .on("mouseout", resize.mouseOut)
            .call(this.setDrag())
            .append("title")
            .text(SingletonInter.$t('propriedades-cana'))
            .node();

          if(newNode.showBox){
            this.createBox()
          }

          g.append('circle')
            .attr("cx", newNode.xDot())
            .attr("cy", newNode.yDot())
            .attr("r", 4)
            .attr("id", 'dot-'+ newNode.id)
            .style("cursor", "pointer")
            .style("fill", '#b5b076')
            .call(this.setDragCircle(newNode))
            .node();

          this.createConnectionPath(newNode, openDialog)
          resize.apply(g, newNode)
      return svg
    }

    this.createBox = function(){
      let d = this.node;
      let g = d3.select(`#InputCana-${d.id}`)

      
      g.append("rect")
        .classed("InputCana", true)
        .attr("x", (d) => d.xRect())
        .attr("y", (d) => d.yRect())
        .attr("stroke", COLORS.OrangePentagro1)
        .style("fill", '#0000')
        .style("width", d.widthRect)
        .style("height", d.heightRect)
        .node();

      d3.selectAll(`#${d.idName} > text.current-attr`).remove()
      d.data.forEach(n => {
        if(n.key == "W" && n.observation){

          g.append('text')
            .attr("id", n.id)
            .classed("current-attr", true)
            .attr("text-anchor", "middle")
            .attr("x", d.xText())
            .attr("y", d.yText())
            .text(n.value ? n.value : "0,00")
            .on('dblclick', () => this.dialog(d))
            .call(this.setDrag())
        }
      })
    }

    this.removeBox = function(){
      let d = this.node
      d3.select(`#${d.idName} > text`).remove()
      d3.select(`#${d.idName} > rect`).remove()
    }
  
    this.setDrag = function() {
      if(this.node.readOnly)
        return d3.drag();

      let that = this
      let drag = d3
        .drag()
        .on("start", that.dragstarted)
        .on("drag", (event,d) => that.dragged(event, d))
        .on("end", that.dragended);

      return drag;
    }

    this.dragstarted = function(event, d) {
      SingletonFlowchart.selectNode(`${d.idName}`);
      d3.select(this).style("cursor", "grabbing")
    }

    this.dragged = async function (event, d) {
      // const adjust = 5;
      d.x = event.x;
      d.y = event.y;
      SingletonFlowchart.clicked = false;

      this.move();
    }

    this.move = async () => {
      let d = this.node;

      await d3.select(`#${d.idName} > image`)
            .raise()
            .attr("x", d.x)
            .attr("y", d.y);

      if(d.showBox){
        d3.select(`#InputCana-${d.id} > rect`)
          .raise()
          .attr("x", d.xRect())
          .attr("y", d.yRect());

        d3.select(`#InputCana-${d.id} > text`)
          .raise()
          .attr("x", d.xText())
          .attr("y", d.yText());
      }

      await d3.select(`#InputCana-${d.id} > circle`)
            .raise()
            .attr("cx", d.xDot())
            .attr("cy", d.yDot());

      d.connectionPack = d.connectionPack.filter(point => d.decorator.ctrConnection.isAlive(point.conn))
      d.connectionPack.forEach(point => point.conn.moveFirstPoint({x: d.xDot(), y: d.yDot()}));

      resize.move(d);
    }

    this.dragended = function() {
      d3.select(this)
        .style("cursor", "pointer") 

      SingletonFlowchart.SaveStatus();
    };

    this.setDragCircle = function(node){
      let that = this
      
      let drag = d3
        .drag()
        .on("start", () => that.conected = true)
        .on("drag", (event) => that.draggedCircle(event, that, node))
        .on("end", (event, node) => that.dragendedCircle(event, that, node));

      return drag;
    }

    this.draggedCircle = (event, that, node) =>{
      if(that.conected && !that.transientConnection){
        that.transientConnection = that.ctrConnection.setNewNode(
          node.xDot(), 
          node.yDot(), 
          `#InputCana-${node.id}`,
          "#b5b076",
          that.dialog,
        )
      }

      that.conected = false;
      that.transientConnection.startMoveConnection({ x: node.xDot(event), y: node.yDot(event)})
    }

    this.dragendedCircle = (event, that, node) =>{
      !that.connected && that.node.connectionPack.push({ conn: that.transientConnection, dot: node.point })
      that.transientConnection = null;
      SingletonFlowchart.SaveStatus();
    }

    this.reloadProperties = () => {
      this.setTextAndAdjustWidth()
    };

    this.setTextAndAdjustWidth = () => {
      let d = this.node
      let isRendering = document.querySelector(`#${d.idName} > rect`)
      let n = d.data.find(a => a.key == "W" && a.observation)

      if(!d.showBox || !n){
        this.removeBox()
        return
      }else{
        if(!isRendering){
          this.createBox();
        }
      }

      d3.select(`#InputCana-${d.id} > rect`)
        .style("width", d.widthRect)
      
      d3.selectAll(`#${d.idName} > text.current-attr`).remove()
      let g = d3.select(`#${d.idName}`)
      g.append('text')
        .attr("id", n.id)
        .classed("current-attr", true)
        .attr("text-anchor", "middle")
        .attr("x", d.xText())
        .attr("y", d.yText())
        .text(n.value ? n.value : "0,00")
        .on('dblclick', d.showBox ? () => this.dialog(d) : () => {})
    }
  }
}